import { infoEstado } from './estados';

const CLASES = {
  verde: 'bg-green-100 text-green-800',
  ambar: 'bg-amber-100 text-amber-800',
  azul: 'bg-blue-100 text-blue-800',
  rojo: 'bg-red-100 text-red-800',
  gris: 'bg-gray-200 text-gray-700',
};

// Chip de estado con color por ciclo de vida. `mapa` es uno de los de
// estados.js; una clave no contemplada cae en "Desconocido" (nunca revienta).
export default function ChipEstado({ mapa, clave }) {
  const { etiqueta, color } = infoEstado(mapa, clave);
  return (
    <span className={`inline-block text-xs font-semibold px-2 py-0.5 rounded ${CLASES[color] || CLASES.gris}`}>
      {etiqueta}
    </span>
  );
}
